var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12" },
        [
          _c("b-card", { staticClass: "bg-light shadow-sm border-0" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-xl-3" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-xl-2 d-flex align-items-center",
                    },
                    [
                      _c("label", { staticClass: "mb-xl-0" }, [
                        _vm._v("Tenant"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-xl-10" },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "rounded-pill",
                          model: {
                            value: _vm.tenantSelection,
                            callback: function ($$v) {
                              _vm.tenantSelection = $$v
                            },
                            expression: "tenantSelection",
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(
                              "\n                    All Tenants\n                  "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.tenants, function (tenant) {
                            return _c(
                              "option",
                              _vm._b(
                                {
                                  key: tenant.id,
                                  domProps: { value: { id: tenant.id } },
                                  on: {
                                    option: function ($event) {
                                      return _vm.$emit(
                                        "option",
                                        $event.target.value
                                      )
                                    },
                                  },
                                },
                                "option",
                                _vm.$attrs,
                                false
                              ),
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(tenant.name) +
                                    "\n                  "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-xl-7 mt-4 mt-xl-0" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-xl-2 text-right d-flex align-items-center",
                    },
                    [
                      _c("label", { staticClass: "mb-xl-0" }, [
                        _vm._v("Time Period"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-xl-5" },
                    [
                      _c("b-form-input", {
                        staticClass: "date-picker rounded-pill",
                        attrs: {
                          id: "dateFrom",
                          type: "date",
                          name: "dateFrom",
                          placeholder: "YYYY-MM-DD",
                        },
                        model: {
                          value: _vm.dateFrom,
                          callback: function ($$v) {
                            _vm.dateFrom = $$v
                          },
                          expression: "dateFrom",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-xl-5 mt-2 mt-xl-0" },
                    [
                      _c("b-form-input", {
                        staticClass: "date-picker rounded-pill",
                        attrs: {
                          id: "dateTo",
                          type: "date",
                          name: "dateTo",
                          placeholder: "YYYY-MM-DD",
                        },
                        model: {
                          value: _vm.dateTo,
                          callback: function ($$v) {
                            _vm.dateTo = $$v
                          },
                          expression: "dateTo",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-xl-2 mt-4 mt-xl-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary px-4 pull-right",
                    attrs: { type: "submit", disabled: _vm.applyBtnDisabled },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.applyButtonClicked.apply(null, arguments)
                      },
                    },
                  },
                  [_c("span", { staticClass: "px-4" }, [_vm._v("Apply")])]
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "animated fadeIn" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-12 col-lg-6 col-xl-3 d-flex align-items-stretch",
          },
          [
            _c("div", { staticClass: "card flex-grow-1" }, [
              _c("div", { staticClass: "card-body align-items-center" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-8" }, [
                    _c("div", { staticClass: "mb-3" }, [
                      _vm._v(
                        "\n                  Total Delivered Devices\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "font-xl font-weight-bold" }, [
                      !_vm.isLoadingOrdersAndRegistrationsList
                        ? _c("span", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.ordersAndRegistrationsList[0]
                                    ? _vm.ordersAndRegistrationsList[0]
                                        .total_delivered
                                    : 0
                                ) +
                                "\n                  "
                            ),
                          ])
                        : _c("span", [
                            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                          ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-lg-6 col-xl-3 d-flex align-items-stretch",
          },
          [
            _c("div", { staticClass: "card flex-grow-1" }, [
              _c("div", { staticClass: "card-body align-items-center" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-8" }, [
                    _c("div", { staticClass: "mb-3" }, [
                      _vm._v(
                        "\n                  Total Registered Devices\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "font-xl font-weight-bold" }, [
                      !_vm.isLoadingOrdersAndRegistrationsList
                        ? _c("span", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.ordersAndRegistrationsList[0]
                                    ? _vm.ordersAndRegistrationsList[0]
                                        .total_registered
                                    : 0
                                ) +
                                "\n                  "
                            ),
                          ])
                        : _c("span", [
                            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                          ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-lg-6 col-xl-3 d-flex align-items-stretch",
          },
          [
            _c("div", { staticClass: "card flex-grow-1" }, [
              _c("div", { staticClass: "card-body align-items-center" }, [
                _c(
                  "div",
                  { staticClass: "row no-gutters align-items-center" },
                  [
                    _c("div", { staticClass: "col-8" }, [
                      _c("div", { staticClass: "mb-3" }, [
                        _vm._v(
                          "\n                  Post Repair NPS\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row position-relative" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c(
                            "div",
                            { staticClass: "font-xl font-weight-bold" },
                            [
                              _vm.isLoadingMarketingMetricsList
                                ? _c("span", [
                                    _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    }),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.marketingMetricsList[0]
                                            ? _vm.marketingMetricsList[0]
                                                .nps_count
                                              ? _vm.marketingMetricsList[0]
                                                  .nps_count
                                              : "N/A"
                                            : "N/A"
                                        ) +
                                        "\n                      "
                                    ),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(2),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "separator" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6" }, [
                          _c(
                            "div",
                            { staticClass: "font-xl font-weight-bold" },
                            [
                              _vm.isLoadingMarketingMetricsList
                                ? _c("span", [
                                    _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    }),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.marketingMetricsList[0]
                                            ? _vm.marketingMetricsList[0].nps
                                              ? _vm.marketingMetricsList[0].nps
                                              : "N/A"
                                            : "N/A"
                                        ) +
                                        "\n                      "
                                    ),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(3),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-4" }, [
                      _c(
                        "div",
                        [
                          _c("DoughnutChart", {
                            attrs: {
                              "chart-data": _vm.npsChartData,
                              options: {
                                displayEndCap: true,
                                maxHeight: "90px",
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-lg-6 col-xl-3 d-flex align-items-stretch",
          },
          [
            _c("div", { staticClass: "card flex-grow-1" }, [
              _c("div", { staticClass: "card-body align-items-center" }, [
                _c(
                  "div",
                  { staticClass: "row no-gutters align-items-center" },
                  [
                    _c("div", { staticClass: "col-8" }, [
                      _c("div", { staticClass: "mb-3" }, [
                        _vm._v(
                          "\n                  Post Repair CSAT\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row position-relative" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c(
                            "div",
                            { staticClass: "font-xl font-weight-bold" },
                            [
                              _vm.isLoadingMarketingMetricsList
                                ? _c("span", [
                                    _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    }),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.marketingMetricsList[0]
                                            ? _vm.marketingMetricsList[0]
                                                .csat_count
                                              ? _vm.marketingMetricsList[0]
                                                  .csat_count
                                              : "N/A"
                                            : "N/A"
                                        ) +
                                        "\n                      "
                                    ),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(4),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "separator" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6" }, [
                          _c(
                            "div",
                            { staticClass: "font-xl font-weight-bold" },
                            [
                              _vm.isLoadingMarketingMetricsList
                                ? _c("span", [
                                    _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    }),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.marketingMetricsList[0]
                                            ? _vm.marketingMetricsList[0]
                                                .satisfied_csat_percentage
                                              ? parseFloat(
                                                  _vm.marketingMetricsList[0]
                                                    .satisfied_csat_percentage
                                                ).toFixed(1)
                                              : "N/A"
                                            : "N/A"
                                        ) +
                                        "%\n                      "
                                    ),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "font-xs" }, [
                            _c("small", [
                              _c("span", [_vm._v("% satisfied")]),
                              _vm._v(" "),
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.bottom",
                                    modifiers: { hover: true, bottom: true },
                                  },
                                ],
                                staticClass: "fa fa-info-circle ml-1",
                                attrs: {
                                  title:
                                    "% of customers satisfied\n(rated 4 or 5)",
                                },
                              }),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("DoughnutChart", {
                          attrs: {
                            "chart-data": _vm.csatChartData,
                            options: {
                              displayEndCap: true,
                              maxHeight: "90px",
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-xl-8" }, [
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body align-items-center" },
              [
                _vm.isLoadingMonthlyRegistrationsList
                  ? _c("div", { staticClass: "text-center" }, [
                      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                    ])
                  : [
                      _c("BarComboChart", {
                        attrs: {
                          title: "Registered Devices",
                          "chart-data": {
                            labels: _vm.registeredDeviceCategories || [],
                            datasets: [
                              {
                                label: "New Registered",
                                type: "bar",
                                data: _vm.totalRegisteredDevices || [],
                                backgroundColor: "#0F2C29",
                                borderColor: "#0F2C29",
                                borderWidth: 1,
                                borderRadius: 4,
                                barPercentage: 0.1,
                                categoryPercentage: 1,
                                yAxisID: "y-axis-1",
                              },
                              {
                                label: "Cumulative Registered",
                                type: "line",
                                data: _vm.cumulativeRegisteredDevices || [],
                                borderColor: "#22D3C5",
                                backgroundColor: "transparent",
                                borderWidth: 4,
                                fill: true,
                                tension: 0,
                                pointBackgroundColor: "#22D3C5",
                                pointBorderColor: "#22D3C5",
                                pointRadius: 0,
                                pointHoverRadius: 0,
                                yAxisID: "y-axis-2",
                              },
                            ],
                          },
                        },
                      }),
                    ],
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-xl-4 d-flex" }, [
          _c(
            "div",
            { staticClass: "card card-body border-brand bg-brand-fill" },
            [
              _c("h4", { staticClass: "font-weight-bold mb-1" }, [
                _vm._v("\n            ROI Dashboard\n          "),
              ]),
              _vm._v(" "),
              _vm.lastUpdatedDate
                ? _c(
                    "p",
                    {
                      staticClass: "mb-3",
                      staticStyle: { color: "#22D3C5", "font-size": "0.8rem" },
                    },
                    [
                      _vm._v(
                        "\n            Last updated: " +
                          _vm._s(_vm.lastUpdatedDate) +
                          "\n          "
                      ),
                    ]
                  )
                : _c("div", { staticClass: "mb-3" }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("div", [
                  _vm._v("\n              Average Cost To Claim\n            "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-right text-brand font-weight-bold font-lg",
                  },
                  [
                    !_vm.isLoadingDamageCausingRepairs &&
                    !_vm.isLoadingWorkOrderClaimSavings
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.averageCostToClaim(),
                                  _vm.currencyCode
                                )
                              ) +
                              "\n              "
                          ),
                        ])
                      : _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("div", [
                  _vm._v("\n              Claims Saved\n            "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-right text-brand font-weight-bold font-lg",
                  },
                  [
                    !_vm.isLoadingDamageCausingRepairs
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.damageCausingRepairsFixed) +
                              "\n              "
                          ),
                        ])
                      : _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("div", [
                  _vm._v(
                    "\n              Estimated Claims Savings\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-right text-brand font-weight-bold font-lg",
                  },
                  [
                    !_vm.isLoadingWorkOrderClaimSavings
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.estimatedClaimsSavings(),
                                  _vm.currencyCode
                                )
                              ) +
                              "\n              "
                          ),
                        ])
                      : _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("div", [
                  _vm._v("\n              Cost of Program\n            "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-right text-brand font-weight-bold font-lg",
                  },
                  [
                    !_vm.isLoadingCostOfProgramme
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.programme(),
                                  _vm.currencyCode
                                )
                              ) +
                              "\n              "
                          ),
                        ])
                      : _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c("div", [
                    _vm._v(
                      "\n              Return On Investment\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-right text-brand-secondary font-weight-bold font-xl",
                    },
                    [
                      !_vm.isLoadingCostOfProgramme &&
                      !_vm.isLoadingWorkOrderClaimSavings
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.roi()) +
                                "\n              "
                            ),
                          ])
                        : _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-xl-4" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-xl-6" }, [
              _c("div", { staticClass: "card flex-grow-1" }, [
                _c("div", { staticClass: "card-body align-items-center" }, [
                  _c("div", { staticClass: "mb-3" }, [
                    _vm._v("\n                  Leak Alerts\n                "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "font-xl font-weight-bold" }, [
                    !_vm.isLoadingLowLeakAlerts
                      ? _c("span", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.lowLeakAlerts.total_lowleak_alerts) +
                              "\n                  "
                          ),
                        ])
                      : _c("span", [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-xl-6" }, [
              _c("div", { staticClass: "card flex-grow-1" }, [
                _c("div", { staticClass: "card-body align-items-center" }, [
                  _c("div", { staticClass: "mb-3" }, [
                    _vm._v(
                      "\n                  Repair Visits\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "font-xl font-weight-bold" }, [
                    !_vm.isLoadingRepairs
                      ? _c("span", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.repairs.total_repairs) +
                              "\n                  "
                          ),
                        ])
                      : _c("span", [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "card flex-grow-1" }, [
                _c("div", { staticClass: "card-body align-items-center" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c("div", { staticClass: "mb-3" }, [
                        _vm._v(
                          "\n                      Claims Saved\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "font-xl font-weight-bold" }, [
                        !_vm.isLoadingDamageCausingRepairs
                          ? _c("span", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.damageCausingRepairs) +
                                  "\n                      "
                              ),
                            ])
                          : _c("span", [
                              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                            ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-6 my-3 text-center" },
                      [
                        _c(
                          "b-progress",
                          {
                            staticClass:
                              "progress shadow-none rounded-pill mb-2",
                            staticStyle: { height: "10px" },
                            attrs: { height: "10px" },
                          },
                          [
                            _c("b-progress-bar", {
                              staticClass: "bg-brand-secondary rounded",
                              attrs: {
                                value: _vm.percentageClaimsInRepairVisits(),
                                max: 100,
                                height: "4px",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v("Of Repairs Visits "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(
                              _vm._s(_vm.percentageClaimsInRepairVisits(true))
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-xl-5" }, [
          _c("div", { staticClass: "card flex-grow-1" }, [
            _c("div", { staticClass: "card-body align-items-center" }, [
              !_vm.isLoadingLeakCategoriesList
                ? _c(
                    "div",
                    [
                      _c("DoughnutChart", {
                        attrs: {
                          title: "Leaks Fixed",
                          "show-labels": true,
                          "chart-data": _vm.leaksFixedChartData,
                          options: {
                            cutoutPercentage: 60,
                            tooltips: { enabled: true },
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _c("span", [
                    _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-xl-3" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body align-items-center" }, [
              _c("h4", { staticClass: "font-weight-bold" }, [
                _vm._v("\n              Customer Feedback\n            "),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              !_vm.isLoadingCustomerFeedbackList
                ? _c(
                    "div",
                    [
                      _c(
                        "ScrollShadowContainer",
                        {
                          attrs: {
                            "max-height": "145px",
                            "shadow-height": "8px",
                            "shadow-color": "rgba(248, 249, 250, 0.9)",
                          },
                        },
                        _vm._l(
                          _vm.customerFeedbackList,
                          function (item, index) {
                            return _c("div", { key: item.leakbot_id }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "font-weight-bold font-lg" },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(item.first_name) +
                                          " " +
                                          _vm._s(item.last_name) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("star-rating", {
                                        attrs: {
                                          rating: Number(
                                            item.csat_engineer_visit
                                          ),
                                          "border-width": 4,
                                          "active-color": "#22D3C5",
                                          "inactive-color": "white",
                                          "border-color": "#22D3C5",
                                          "rounded-corners": false,
                                          "star-points": [
                                            23, 2, 14, 17, 0, 19, 10, 34, 7, 50,
                                            23, 43, 38, 50, 36, 34, 46, 19, 31,
                                            17,
                                          ],
                                          "star-size": 12,
                                          "show-rating": false,
                                          "read-only": true,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mb-2" }, [
                                _c("small", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm._f("moment")(item.created_on)
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mb-2" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.customer_feedback) +
                                    "\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "font-weight-bold font-lg" },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(item.leakbot_id) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              index !== _vm.customerFeedbackList.length - 1
                                ? _c("hr")
                                : _vm._e(),
                            ])
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLoadingCustomerFeedbackList
                ? _c("div", { staticClass: "text-center" }, [
                    _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4 text-right" }, [
      _c("div", { staticClass: "icon-background" }, [
        _c("img", {
          attrs: {
            src: "static/img/delivered_devices.svg",
            alt: "Total Delivered Devices",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4 text-right" }, [
      _c("div", { staticClass: "icon-background" }, [
        _c("img", {
          attrs: {
            src: "static/img/registered_devices.svg",
            alt: "Total Registered Devices",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "font-xs" }, [
      _c("small", [_vm._v("Total respondents")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "font-xs" }, [
      _c("small", [_vm._v("Actual score")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "font-xs" }, [
      _c("small", [_vm._v("Total respondents")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }